import {
  ItemsToVerifyType
} from '@generated/graphql';
import {BaseModel} from '@shared/models/base.model';
import { ItemToVerify } from './item-to-verify.model';
import { itemToVerifyFactory } from '../factories/item-to-verify.factory';

export class ItemsToVerify extends BaseModel implements ItemsToVerifyType {
  id: string;
  total: number;
  items: ItemToVerify[];
  allVerified: boolean;

  constructor(state: ItemsToVerifyType) {  
    super(state);
    this.items = itemToVerifyFactory.createEntities(state.items);
  }

  getModelName(): string {
    return "";
  }
}
